/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  helper: {
    fontSize: '0.7em',
  },
});

const PreviewPlaceholder = ({ classes, placeholder }) => (
  <div>
    <p>{placeholder}</p>
    <span className={classes.helper}>
      Recommended size of 2400 x 800 pixels
    </span>
  </div>
);

PreviewPlaceholder.defaultProps = {
  placeholder: 'Drop a background image here',
};

export default withStyles(styles)(PreviewPlaceholder);
